
<template>

<footer>
Powered by
  <img class="box fade-in one" style="width:175px; display:block;margin:12px auto;" src="https://presale.getwifi.no/assets/tm_black.png" alt="Logo Telenor Maritime">




  <div style="font-size: 11px; display: none;">
    <span v-if="loginStatus" v-on:click="LogOut()">Log out</span> | 
    <span>Logged in: {{ loginStatus }}</span> | 
      <span @click="toggleLoginForm = !toggleLoginForm" >Logg inn</span>



<div v-if="toggleLoginForm">
    un: <input type="text" id="un" value="test1"><br>    
    pw: <input type="text" id="pw" value="pass1"><br>  
    <div><button href="#" v-on:click="LogIn()">Logg inn</button></div>
</div>
  </div>

</footer>



  </template>
 
 
 <style>
  footer {
    padding: 25px 0;
    /* border-top: 1px solid #e5e5e5; */
    /* padding-top: 20px; */
    background-color: #fff;
  }
</style>
  
  
  <script setup>
  import { ref, onBeforeMount,onMounted } from 'vue'
  import { CheckStatus2,loginStatus } from '@/modules/modules.js'
  
  //const authStatus = ref([])
  let toggleLoginForm = ref(false);

  console.log("here:" +  process.env.VUE_APP_API_EDNPOINT);
  
  
  
  
  onBeforeMount(async () => {

      CheckStatus2()
  })
  
  
  onMounted(async () => {

     // CheckStatus2()
  })
  


  
  
  
  function LogOut()
  {
    localStorage.removeItem('tmToken');

    CheckStatus2();
  }
  


  
  function LogIn()
  {
    var myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  
  var raw = JSON.stringify({
    "username": document.getElementById("un").value,
    "password": document.getElementById("pw").value
  });
  
  var requestOptions = {
    method: 'POST',
    headers: myHeaders,
    body: raw,
    redirect: 'follow'
  };
  
  fetch( process.env.VUE_APP_API_EDNPOINT+"/users/authenticate", requestOptions)
    .then(response => response.text())
    .then(result => {
      console.log(result);
      if(JSON.parse(result).id != null )
          {
                //document.getElementById("response").innerHTML = "Logged in user: " +JSON.parse(result).username;
                console.log("Logged in user: " +JSON.parse(result).username);
                localStorage.setItem('tmToken', JSON.parse(result).token)
          }
          else
          {
                document.getElementById("response").innerHTML = JSON.parse(result).message;
                console.log("Error: " + JSON.parse(result).message);
          }
  
    
          CheckStatus2();
    })
    .catch(error => console.log('error', error));
  }
  </script>